import { P2GBox, P2GLink, P2GGrid } from '@parcel2go/core-ui';
import { useContext } from 'react';
import { LayoutIndent } from '../../lib/consts/LayoutConstants';
import { FixedColumn } from '../FixedColumn';
import { SmartSendContext } from '../../lib/context/SmartSendContext';
import { UpdateFilterAction } from '../../lib/context/SmartSendContextModels';
import { SmartSendFilterContext, SortField } from '../../lib/helpers/SmartSendFilterApplier';
import { Trans, useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
import { AppCard } from '~/components/card/app-card';
import QuickToggleAll from './quickselect/QuickToggleAll';

interface props {
  selected: number;
  total: number;
  filter: SmartSendFilterContext;
  filterKey: string;
}

export default function SmartSendSoldHeaderRow(props: props) {
  const ctx = useContext(SmartSendContext);
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  const p = 1;

  const currentSortField = props.filter.CurrentFilter.SortField;
  const currentSortOrder = props.filter.CurrentFilter.SortOrder;

  const setField = (sortField: SortField) => {
    if (props.filter.CurrentFilter.DisableSort) {
      return;
    }
    ctx.dispatch(
      new UpdateFilterAction(props.filterKey, {
        ...props.filter,
        CurrentFilter: {
          ...props.filter.CurrentFilter,
          SortField: sortField,
          SortOrder: currentSortField !== sortField ? currentSortOrder : currentSortOrder === 'asc' ? 'desc' : 'asc'
        }
      })
    );
  };

  const arrows = <> {currentSortOrder == 'asc' ? '🡅' : '🡇'} </>;

  return (
    <AppCard>
      <P2GBox pl={1} pr={1}>
        <FixedColumn
          alignItems="center"
          right={
            <P2GGrid container spacing={1} alignItems="center">
              <P2GGrid item xs={12} sm={4}>
                <P2GBox p={p}>
                  <P2GLink colour="primary" onClick={() => setField('Product')} underline="none">
                    <Trans
                      t={t}
                      i18nKey="ORDER_DETAILS_TABLE_HEADER"
                      components={[<strong />]}
                      defaults="<strong>Order Details</strong>"
                    />
                    {currentSortField === 'Product' && arrows}
                  </P2GLink>
                </P2GBox>
              </P2GGrid>
              <P2GGrid item xs={12} sm={3}>
                <P2GBox p={p}>
                  <P2GLink colour="primary" onClick={() => setField('Recipient')} underline="none">
                    <Trans
                      t={t}
                      i18nKey="CUSTOMER_TABLE_HEADER"
                      components={[<strong />]}
                      defaults="<strong>Customer</strong>"
                    />
                    {currentSortField === 'Recipient' && arrows}
                  </P2GLink>
                </P2GBox>
              </P2GGrid>
              <P2GGrid item xs={12} sm={5}>
                <P2GBox p={p}>
                  <P2GLink colour="primary" onClick={() => setField('Service')} underline="none">
                    <Trans
                      t={t}
                      i18nKey="SERVICE_AND_COURIER_TABLE_HEADER"
                      components={[<strong />]}
                      defaults="<strong>Service / Courier</strong>"
                    />
                    {currentSortField === 'Service' && arrows}
                  </P2GLink>
                </P2GBox>
              </P2GGrid>
            </P2GGrid>
          }
          left={<QuickToggleAll filterKey={props.filterKey} selected={props.selected} total={props.total} />}
          width={LayoutIndent}
        />
      </P2GBox>
    </AppCard>
  );
}
